import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Send me a Deyem.",
  "Messaging that remembers.",
  "Message like you always have.",
  "Organisation without the organising.",
  "If you can send a message, you can use Deyem.",
];

export const EditorialMarquee = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`py-10 border-y ${dark ? "bg-diem-ink border-white/10" : "bg-white border-diem-line"}`}
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span
            className={`font-display text-3xl sm:text-4xl font-medium tracking-tight whitespace-nowrap ${
              dark ? "text-white/35" : "text-diem-ink/25"
            }`}
          >
            {t}
          </span>
          <Asterisk className={`w-7 h-7 mx-10 sm:mx-14 ${dark ? "text-diem-sky/50" : "text-diem-blue/40"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);
